module.exports = __webpack_public_path__ + "static/bitcoin-video-b9908a7d18aaaedfd9e819ae1bb071d9.mp4";